// extracted by mini-css-extract-plugin
export default {"modalContainer":"ModalSectionService_modalContainer__yiine"};